export function useIntervalChanger(input: { next: () => number; curr: () => number; set: (value: number) => void }): void {
  if (import.meta.server) return
  const interval2 = useInterval('useIntervalChanger', true)

  function watchChange(end: number) {
    const step = Math.max(1, Math.ceil(Math.abs(input.curr() - end) / 22)) + 0.11
    interval2.set(() => {
      const cur = input.curr()
      if (Math.abs(end - cur) > step) {
        if (end < cur) return input.set(input.curr() - step)
        if (end > cur) return input.set(input.curr() + step)
      } else {
        input.set(end)
        interval2.clear()
      }
    }, 20)
  }

  watch(() => input.next(), (i) => watchChange(i))
}
